import React from 'react';
import SycaiLoadingIndicator from './SycaiLoadingIndicator';

// Mirror of OHIF's LoadingIndicatorTotalPercent (platform/ui-next ...
// /LoadingIndicatorTotalPercent.tsx), registered under `ui.loadingIndicatorTotalPercent`.
// Overriding `ui.loadingIndicatorProgress` alone does NOT rebrand the SEG/RT/PMAP viewport
// loaders: that upstream component imports LoadingIndicatorProgress DIRECTLY (not through the
// customization service), so those viewports still render <Icons.LoadingOHIFMark/>. This
// reproduces its textBlock/progress logic verbatim and delegates to SycaiLoadingIndicator (the
// Sycai mark). Props mirror the upstream signature; a change there would render mismatched props.
interface Props {
  className?: string;
  totalNumbers: number | null;
  percentComplete: number | null;
  loadingText?: string;
  targetText?: string;
}

export function SycaiLoadingIndicatorTotalPercent({
  className,
  totalNumbers,
  percentComplete,
  loadingText = 'Loading...',
  targetText = 'segments',
}: Props) {
  const progress = percentComplete;
  const totalNumbersText = totalNumbers !== null ? `${totalNumbers}` : '';
  const numTargetsLoadedText =
    percentComplete !== null ? Math.floor((percentComplete * totalNumbers) / 100) : '';

  const textBlock =
    !totalNumbers && percentComplete === null ? (
      <div className="text-foreground text-sm">{loadingText}</div>
    ) : !totalNumbers && percentComplete !== null ? (
      <div className="text-foreground text-sm">Loaded {percentComplete}%</div>
    ) : (
      <div className="text-foreground text-sm">
        Loaded {numTargetsLoadedText} of {totalNumbersText} {targetText}
      </div>
    );

  return (
    <SycaiLoadingIndicator
      className={className}
      progress={progress}
      textBlock={textBlock}
    />
  );
}

export default SycaiLoadingIndicatorTotalPercent;
